import { render, staticRenderFns } from "./InstallPwaNotice.vue?vue&type=template&id=2401bcb6&"
import script from "./InstallPwaNotice.vue?vue&type=script&lang=ts&"
export * from "./InstallPwaNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports